type Props = {
  label: string;
  value: string;
  accent?: boolean;
};

export function Stat({ label, value, accent = false }: Props) {
  return (
    <div className="text-right">
      <div className="text-xs uppercase tracking-wide text-gray-500">{label}</div>
      <div className={`tabular-nums text-lg font-semibold ${accent ? 'text-emerald-600' : ''}`}>
        {value}
      </div>
    </div>
  );
}
